<template>
  <b-modal
    :visible="show"
    class="modal-content"
    :centered="true"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    hide-footer
    hide-header
  >
    <template #default>
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" data-dismiss="modal" class="modal-close" aria-label="Cancel" @click="cancelRefresh()">
            <i class="fas fa-lg fa-times"></i>
          </button>
        </div>
        <div class="modal-body text-center">
          <i class="fas fa-exclamation-circle my-3 mb-5 fa-5x text-danger"></i>
          <h1 class="my-4">Are you sure you want to refresh your basket?</h1>
        </div>
        <div class="modal-footer d-flex justify-content-center">
          <button class="btn btn-tertiary mr-2" id="cancelButton" @click="cancelRefresh()" data-dismiss="modal">
            Cancel
          </button>
          <button class="btn btn-danger" @click="confirmRefresh()" data-dismiss="modal">Confirm</button>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>
export default {
  props: {
    show: {
      Type: Boolean,
      default: false,
    },
  },
  methods: {
    cancelRefresh: function() {
      this.$emit("cancel-refresh");
    },
    confirmRefresh: function() {
      this.$emit("confirm-refresh");
    },
  },
};
</script>
